import React from 'react';
import PropTypes from 'prop-types';

const DashboardRow = props => {
    return (
        <div className="row">
            {props.children}
        </div>
    );
};

DashboardRow.propTypes = {
    children: PropTypes.node
};

export default DashboardRow;